import { cn } from "@/shared/lib/cn";

/**
 * Heat-метрики кластера. Сами кластеры в этап 8 будут жить в
 * `entities/projects`, пока тип объявлен локально, чтобы виджет
 * остался переиспользуемым.
 */
export interface HeatOut {
  temperature: string;
  trend_pct: number | null;
}

const STYLES: Record<string, { bg: string; border: string; color: string; emoji: string }> = {
  hot:     { bg: "bg-pink/12",   border: "border-pink/35",   color: "text-pink",   emoji: "🔥" },
  rising:  { bg: "bg-amber/12",  border: "border-amber/35",  color: "text-amber",  emoji: "📈" },
  stable:  { bg: "bg-green/12",  border: "border-green/35",  color: "text-green",  emoji: "🟢" },
  cooling: { bg: "bg-cyan/12",   border: "border-cyan/35",   color: "text-cyan",   emoji: "📉" },
  frozen:  { bg: "bg-white/5",   border: "border-white/12",  color: "text-muted-foreground", emoji: "❄️" },
  unknown: { bg: "bg-white/5",   border: "border-white/10",  color: "text-muted-foreground", emoji: "❓" },
};

export function TempBadge({ heat }: { heat: HeatOut | null }): JSX.Element {
  const t = heat?.temperature ?? "unknown";
  const s = STYLES[t] ?? STYLES.unknown!;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-bold tabular-nums",
        s.bg, s.border, s.color,
      )}
    >
      <span className="text-sm leading-none">{s.emoji}</span>
      {t === "unknown" || heat?.trend_pct == null
        ? null
        : `${heat.trend_pct > 0 ? "+" : ""}${Math.round(heat.trend_pct)}%`}
    </span>
  );
}
